import AchStatus from './AchStatus';

export const serviceOfferingIds = {
  GR_WATER: 'gr_water',
  GR_REFUSE: 'gr_refuse',
  KS_DMV: 'ks_dmv',
  KS_DL: 'ks_drivers_license',
  KS_DL_COA: 'ks_dl_address_change',
  NC_DMV: 'ncdmv',
  JACKSON_PROPERTY_TAX: 'jackson_property_tax',
  NC_DL: 'nc_drivers_license',
  NCDMV_DRIVING_RECORD: 'ncdmv_driving_record',
  NCDMV_HEARING_FEE: 'ncdmv_hearing_fee',
  NC_HANDICAP_PLACARD: 'nc_handicap_placard',
  NC_IDENTITY_VERIFICATION: 'nc_identity_verification',
  NCDMV_DRIVEWAY_PERMITS: 'ncdmv_driveway_permits',
  NCDMV_CRASH_REPORTS: 'ncdmv_crash_reports',
  NC_HF_AHS: 'ncdmv_hearing_fee_license_and_theft',
  NC_CP_AHS: 'ncdmv_civil_penalty_license_and_theft',
  OK_DMV: 'ok_vehicle_registration',
  NC_INSURANCE_LAPSE: 'ncdmv_insurance_lapse',
  NC_HF_LITES: 'ncdmv_hearing_fee_lite',
  PAYABLE_REMINDER_SERVICE: 'payable_reminder_service',
  BEAUFORT_COUNTY_PROPERTY_TAX: 'beaufort',
  SHELBY_PROPERTY_TAX: 'shelby_tax',
};

export const tabKeys = {
  ACTIVITY_LOGS_KEY: 'Activity Logs',
  STEPPED_PATHWAYS_KEY: 'Stepped Pathways',
  CHARGE_BACK_KEY: 'Chargeback',
  COPY_DOCUMENTS_KEY: 'Copy Documents',
  CONVERSATION_VIEWER_KEY: 'Conversation Viewer',
  CUSTOMER_PROFILE_KEY: 'Customer Profile',
  COMMUNICATION_PREFERENCES_KEY: 'Communication Preferences',
  LINK_CUSTOMER_ACCOUNTS_KEY: 'Link Customer Accounts',
  UNENROLL_SAML_USERS_KEY: 'Unenroll Users from SAML',

  SMS_SEARCH_KEY: 'SMS Search',
  ENCRYPT_DECRYPT_KEY: 'Encrypt/Decrypt',
  REFUND_KEY: 'Refund',
  REMOVE_USER_KEY: 'Remove User',
  RESEND_TDC_KEY: 'Resend TDC',
  TRANSACTION_SEARCH_KEY: 'Transaction Search',
  SCHEDULED_TRANSACTION_SEARCH: 'Scheduled Transaction Search',
  BULK_GEN_RESOLVE_KEY: 'Bulk gen_resolve',
  BULK_REFUND_JSON_GENERATOR_KEY: 'Bulk Refund JSON Generator',
  MANAGED_PAY_KEY: 'Managed Pay',
  AUTOPAY_KEY: 'Autopay',
  AUTOPAY_STATUS_KEY: 'Autopay Status',
  SEND_EMAIL_KEY: 'Send Email',
  UNLINK_CUSTOMER_KEY: 'Unlink Customer',
  UPDATE_USERNAME_KEY: 'Update Username',
  REMOVE_AUTOPAY_KEY: 'Remove Autopay',
  REMOVE_EBILLING_KEY: 'Remove E-billing',
  NCDMV_KEY: serviceOfferingIds.NC_DMV,
  NC_HIGHWAY_PATROL_KEY: serviceOfferingIds.NC_HIGHWAY_PATROL,
  KS_DMV_KEY: serviceOfferingIds.KS_DMV,
  KS_DL_KEY: serviceOfferingIds.KS_DL,
  KS_DL_COA_KEY: serviceOfferingIds.KS_DL_COA,
  OK_DMV_KEY: serviceOfferingIds.OK_DMV,
  GR_WATER_KEY: serviceOfferingIds.GR_WATER,
  GR_WATER_V2_KEY: `${serviceOfferingIds.GR_WATER}_v2`,
  PBC_COURTS_KEY: serviceOfferingIds.PBC_COURTS,
  SERVICE_MANAGEMENT_KEY: 'Service Management',
  GR_REFUSE_KEY: serviceOfferingIds.GR_REFUSE,
  KCK_TAX_KEY: 'kck_tax',
  KCK_TAX_PERSONAL_KEY: 'kck_tax_personal',
  JACKSON_KEY: serviceOfferingIds.JACKSON_PROPERTY_TAX,
  FLORIDA_DMV_KEY: 'fldmv',
  GR_BLOCK_GRANTS_KEY: 'gr_block_grants',
  GR_PARKING_KEY: 'gr_parking',
  STL_PROPERTY_KEY: 'stl_property',
  STL_WATER_KEY: 'stl_water',
  STL_REAL_ESTATE_KEY: 'stl_real_estate',
  IVR_KEY: 'ivr',
  GR_PROPERTY_TAX_KEY: 'gr_property_tax',
  PROPERTY_TAX_KEY: 'PropertyTaxVertical',

  SERVICE_FEE_VIEW: 'ServiceOfferingFees',
  EBILL_CUSTOMER_VIEW: 'Ebill',
  EBILL_SEND: 'EbillSend',
  EBILL_TRIAL_SEND: 'EbillTrialSend',
  NCDL_KEY: serviceOfferingIds.NC_DL,
  NCDMV_DRIVING_RECORD_KEY: serviceOfferingIds.NCDMV_DRIVING_RECORD,
  NCDMV_HEARING_FEE_KEY: serviceOfferingIds.NCDMV_HEARING_FEE,
  NC_HANDICAP_PLACARD: serviceOfferingIds.NC_HANDICAP_PLACARD,
  NC_IDENTITY_VERIFICATION: serviceOfferingIds.NC_IDENTITY_VERIFICATION,
  NCDMV_DRIVEWAY_PERMITS: serviceOfferingIds.NCDMV_DRIVEWAY_PERMITS,
  NCDMV_CRASH_REPORTS: serviceOfferingIds.NCDMV_CRASH_REPORTS,
  NC_HF_AHS: serviceOfferingIds.NC_HF_AHS,
  NC_CP_AHS: serviceOfferingIds.NC_CP_AHS,
  BEAUFORT_MV_BILLS_KEY: 'Beaufort MV Bills',
  BEAUFORT_UNENROLLMENT_KEY: 'Beaufort Unenrollments',
  BATCH_PAY_KEY: 'Batch Pay',
  AVS_WHITELIST_KEY: 'ACH Account Verification',
  EBILLING: 'eBilling',
  NC_INSURANCE_LAPSE_KEY: serviceOfferingIds.NC_INSURANCE_LAPSE,
  NC_HF_LITES_KEY: serviceOfferingIds.NC_HF_LITES,
  PAYABLE_REMINDER_SERVICE_KEY: 'Payable Reminder Service',
  QUEUE_ITEM_SEARCH: 'Failed Queue Item Search',
  MANUAL_RETRY_KEY: 'Manual Retry',
  PRODUCT_LAUNCH_ALERTS_KEY: 'Product Launch Alerts',
  BEAUFORT_KEY: `${serviceOfferingIds.BEAUFORT_COUNTY_PROPERTY_TAX}_v1`,
  SHELBY_KEY: `${serviceOfferingIds.SHELBY_PROPERTY_TAX}_v1`,
};

export const validation = {
  message: {
    TRANSACTION_ID_REQUIRED: 'Transaction ID is a required field.',
  },
};

export const V2 = 2;
export const V3 = 3;
export const POS = 'pos';
export const cartingServiceScheduledTransaction = 'cssp';
export const paymentScheduledServiceTransaction = 'pss';
export const ACH_STATUS = AchStatus;
export const EMPTY_GRID_DEFAULT_MESSAGE = 'No data to show';
export const PAYIT_TENANT_USER_ID = 'tenant.user.id';
